import axios from "axios";

export default {
    getTimezones: async () => {
        const { data } = await axios.get(`/timezones/`)

        return data
    },
}